import script from "./TransactionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionItem.vue?vue&type=script&setup=true&lang=js"

import "./TransactionItem.vue?vue&type=style&index=0&id=454a9ec8&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454a9ec8"]])

export default __exports__